import EventTarget from '@deezer/event-target';
import BridgeEvent, { BridgeEvents } from "./events.js";
export class BaseTarget extends EventTarget {}
function hasProp(obj, key) {
  return key != null && obj != null && typeof obj === 'object' && key in obj;
}
export class WebviewBridgeListener {
  constructor() {
    this.target = new BaseTarget();
    this.listener = event => {
      if (!event.data || typeof event.data !== 'object') {
        return;
      }
      if (!hasProp(event.data, 'type') || typeof event.data.type !== 'string') {
        return;
      }
      if (Object.values(BridgeEvents).includes(event.data.type)) {
        this.target.dispatchEvent(new BridgeEvent(event.data.type, {
          detail: hasProp(event.data, 'detail') ? event.data.detail : null
        }));
      }
    };
    this.on = this.target.addEventListener.bind(this.target);
    this.off = this.target.removeEventListener.bind(this.target);
    if (typeof window !== 'undefined') {
      window.addEventListener('message', this.listener);
    }
  }
  destroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('message', this.listener);
    }
  }
}
//# sourceMappingURL=WebviewBridgeListener.js.map